var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check"},[_c('p',[_vm._v("PDF链接："),_c('span',{staticClass:"link",on:{"click":_vm.handleToFile}},[_vm._v(_vm._s(_vm.morePdfs))])]),_c('div',{staticClass:"check-btn"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.handleSure}},[_vm._v("确定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }